import { FormEvent, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Button, Col, Form, Row } from "react-bootstrap"
import { getUrlSearchParams } from "../../urlParams"
import { ApiEndpoints, reqPatch, reqPostNew, reqPut } from "../../../config/apiClient"
import removeAllErrorMsg from "../../../components/funcRemoveAllErros"
import funcSleep from "../../../components/funcSleep"
import LoadingModal from "../../../components/loadingModal"
import { defineValueInInput } from "../../../components/funcForInput"
import LocalProdutosLista from "./LocalProdutosLista"
import { useDispatch, useSelector } from "react-redux"
import { atualizarProdutos } from "./InsumosLocalSlice"

function InsumosLocaisFormPage() {
    const [loading, setLoading] = useState<boolean>(false)
    const [dados, setDados] = useState<any>({})
    const localProdutos: any[] = useSelector((state: any) => state.uiInsumosLocal.produtos)
    const dispatch = useDispatch()

    useEffect(() => {
        document.title = "Cadastrar Local Insumo | OB PORTUS"
        loadingPage()
        // eslint-disable-next-line
    }, [])
    async function loadingPage() {
        const urlDados = getUrlSearchParams()
        const id = urlDados.get("id")
        if (id !== null) {
            getDados(Number(id))
            document.title = "Editar Local Insumo | OB PORTUS"
        }
    }
    async function getDados(id: number) {
        setLoading(true)
        const dadosId = {
            id_local: Number(id)
        }
        const api = await reqPostNew(ApiEndpoints.insumosLocal, dadosId)
        if (api.status === 200) {
            const registro: any = api.data
            setDados(registro)
            defineValueInInput('id_local', registro.id_local)
            defineValueInInput('descricao', registro.descricao)
            defineValueInInput('status', registro.situacao)
            let localProdutosAux = registro.produtos
            localProdutosAux = localProdutosAux.map((prod: any, idx: any, arr: any) => {
                return {
                    id: prod.id,
                    id_local: prod.id_local,
                    id_produto: prod.id_produto.id_produto,
                    id_unidade: prod.id_unidade.id_unidade,
                    qtd: prod.qtd,
                }
            })
            dispatch(atualizarProdutos({ produtos: localProdutosAux }))
            document.title = `Editar ${registro.descricao} | OB PORTUS`
        }
        setLoading(false)
    }

    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault()
        event.stopPropagation()
        removeAllErrorMsg()

        const form: any = event.target
        let formValidado = true
        let dadosForm = {
            id_local: Object.values(dados).length === 0 ? 0 : dados.id_local,
            descricao: form.descricao.value,
            situacao: Number(form.status.value),
            produtos: localProdutos,
        }

        // cod_serv: Object.values(clienteDados).length > 0 ? clienteDados?.cod_serv : form.cod_serv.value,
        //     descricao: form.descricao.value,
        //     iss_incidencia_municipio_prestador: form.iss.value,

        if (dadosForm.descricao === "") {
            form.descricao.nextElementSibling.style.display = "block"
            formValidado = false
        }
        if (dadosForm.id_local! <= 0 || dadosForm.id_local === null) {
            dadosForm.id_local = null
        }

        let possui_prod_duplicado = false
        for (let idx in dadosForm.produtos) {
            let prod = dadosForm.produtos[idx]
            if (prod.qtd <= 0) {
                form[`${idx}-qtd`].nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (prod.id_produto === 0) {
                form[`${idx}-id_produto_aux`].nextElementSibling.style.display = "block"
                formValidado = false
            }
            if (prod.id_unidade === 0) {
                form[`${idx}-id_unidade_aux`].nextElementSibling.style.display = "block"
                formValidado = false
            }
            let qtd_encontrado = 0
            for (let prodaux of dadosForm.produtos) {
                if (prodaux.id_produto === prod.id_produto && prodaux.id_unidade === prod.id_unidade) {
                    qtd_encontrado += 1
                }
            }
            if (qtd_encontrado > 1) {
                possui_prod_duplicado = true
            }
        }
        if (possui_prod_duplicado) {
            window.alert("Verifique a lista, existem produtos duplicados!")
            formValidado = false
        }

        console.info(dadosForm)

        if (!formValidado) {
            return
        }
        if (Object.values(dados).length === 0) {
            cadastrar(dadosForm)
        }
        if (Object.values(dados).length > 0) {
            editar(dadosForm)
        }

    }

    async function cadastrar(dados: any) {
        setLoading(true)
        const api = await reqPut(ApiEndpoints.insumosLocalCadastrar, dados)
        if (api.status === 201) {
            console.log(api.data)
            toast.success('Local cadastrado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await funcSleep(500)
            window.location.assign(`/insumos/locais`)
        }
        setLoading(false)
    }
    async function editar(dados: any) {
        setLoading(true)
        const api = await reqPatch(ApiEndpoints.insumosLocalEditar, dados)
        if (api.status === 200) {
            console.log(api.data)
            toast.success('Local editado com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await funcSleep(500)
            window.location.assign(`/insumos/locais`)
        }
        setLoading(false)
    }
    async function handleExcluirTipo() {
        if (!window.confirm('Tem certeza que deseja excluir o Local?')) {
            return
        }
        const dadosAux = {
            id_local: dados.id_local,
        }
        setLoading(true)
        const api = await reqPostNew(ApiEndpoints.insumosLocalDeletar, dadosAux)
        if (api.status === 200) {
            console.log(api.data)
            toast.success('Local excluído com sucesso!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            await funcSleep(500)
            window.location.assign(`/insumos/locais`)
        }
        setLoading(false)
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={(event: any) => {
                setLoading(!loading)
            }} />
            <div className="div-row-space-between">
                <h1 id="titleMain">Insumos Local</h1>
                <Button variant="secondary" onClick={() => { window.location.assign(`/insumos/locais`) }}>Voltar</Button>
            </div>
            <br></br>
            <Form id='formInsumosLocal' onSubmit={handleSubmit} noValidate>
                <Row className="mb-15-forms">
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Cod. Local:</Form.Label>
                            <Form.Control name='id_local' type="number" id='id_local' placeholder="" readOnly disabled />
                        </Form.Group>
                    </Col>
                    <Col className="col-5">
                        <Form.Group>
                            <Form.Label>Descrição:</Form.Label>
                            <Form.Control name='descricao' type="text" id='descricao' placeholder="" />
                            <Form.Control.Feedback type="invalid">
                                Informe o Descrição!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-2">
                        <Form.Group>
                            <Form.Label>Status:</Form.Label>
                            <Form.Select name="status" id="status" aria-label="">
                                <option value="1">Ativo</option>
                                <option value="0">Desativado</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                Informe o Status!
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <LocalProdutosLista local={dados} />

                {
                    Object.values(dados).length === 0 &&
                    <Button variant="success" type="submit" disabled={loading}>{loading ? 'Aguarde ...' : 'Cadastrar'}</Button>
                }

                {
                    Object.values(dados).length > 0 &&
                    <Button variant="success" type="submit" disabled={loading} style={{ marginRight: '10px' }}>{loading ? 'Aguarde ...' : 'Editar'}</Button>
                }

                {
                    Object.values(dados).length > 0 &&
                    <Button variant="danger" disabled={loading} style={{ marginRight: '10px' }} onClick={() => { handleExcluirTipo() }}>{loading ? 'Aguarde ...' : 'Deletar'}</Button>
                }
            </Form>
        </div>
    )
}

export default InsumosLocaisFormPage